import { proxy } from 'valtio';
import { proxyMap, proxySet } from 'valtio/utils';
import { CURSOR_MODE, WELL_BUILD_TYPES } from './constants';
import type { Layer } from '../layers';
import type { MODALS, GtmType, ContourData, ShapeFile } from './constants';
import type { MapTemplate } from '../templates';

const stateInit = () => ({
    loading: false,
    loadingLabel: '' as string | JSX.Element,
    modal: null as MODALS | null,
    appendNewField: false,

    // Базовые настройки загружаемой карты
    rigis: null as number | null,
    // TODO: deprecated, will be removed
    field: null as number | null,
    fields: [] as Array<{ id: number; label: string }>,
    fieldName: null as string | null,
    stratums: [] as number[],
    wells: proxyMap<number, string>(),
    versions: [] as number[],

    // Toolbar
    cursorMode: CURSOR_MODE.VIEWING,
    scale: 64000, // текущий зум карты 1:X
    userCircleMode: false,
    drawMode: false, // окно работы с выбранными скважинами
    showSearch: false,

    selectedUserCircle: null as { id: number; radius: number | null; x: number; y: number } | null,

    // Inspector (layers)
    selectedWells: new Array<any>(),
    checkedSelectedWells: {} as { [key: string]: boolean },
    loadedLayersData: proxySet<string>(), // слои с загруженными данными. Ключ - pattern.key
    layerStructure: proxyMap<string, Layer>(), // Дерево слоев в "плоском" хранилище для реактивности. Ключ - guid слоя
    layerVisibility: proxyMap<string, boolean>(), // Видимость слоев. Ключ - guid слоя
    layerSettings: proxyMap<string, Record<string, unknown>>(), // Значения свойств слоев. Ключ - guid слоя
    selectedLayer: null as unknown as Layer,
    // DatePicker
    minDate: new Date(),
    maxDate: new Date(),
    dateToLoad: undefined as Date | undefined,
    loadedDate: [] as Date[],
    datesOnLoad: [] as Date[],
    currentDate: new Date(),

    // Состояния загрузки расширенных данных слоев production
    productionDateToLoad: undefined as Date | undefined,
    productionLoadedDate: [] as Date[],
    productionDatesOnLoad: [] as Date[],

    // ColorPicker (наверное, временно тут)
    colorPickerData: {
        defaultColor: '' as string,
        defaultAlpha: 0 as number,
        onApply: (() => null) as (newColor: string, newAlpha: number) => void,
        onCancel: (() => null) as () => void,
    },

    // Подгружаемые данные для формирования списка свойств слоев
    wellBoreGeometry: [] as Array<{ id: number; title: string }>, // Типы стволов
    wellBoreType: [] as Array<{ id: number; title: string }>, // Геометрия ствола
    wellBuildType: WELL_BUILD_TYPES, // Типы построения (По пластам, по устью, по забоям). Константа, но когда она живет тут гораздо нагляднее
    uniqueStrataList: [] as Array<{ field_id: number; stratum_id: number; stratum_name: string; key: string }>,
    stratumsLegendTransit: {} as Record<string, string>, // Пластпересечения для слоя транзитных скважин

    gtmTypes: [] as GtmType[],
    contourData: [] as ContourData[],

    shapeFiles: [] as ShapeFile[],
    shapeModalSelectionByLayer: proxyMap<string, Record<number, { checked: boolean; title: string }>>(),
    // временно, для отладки
    savedTemplates: [] as MapTemplate[],

    requestWells: {},
    requiredInjection: {},
    requiredInjectionTables: {},
    activeStratumId: null,
    activeStratumKey: '',
    isVoronoiReady: false,
    wellTransitLoaded: false,
});

export const state = proxy(stateInit());
